import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { PortalShell, PORTAL_NAV, terminologyOf, type NavItem } from '@getpay93/ui';
import { useAuth } from '../auth/AuthContext';
import { ProfileSwitcher } from '../shell/ProfileSwitcher';
import { useUnreadCount, useNotificationsStream } from '../shell/NotifBell';
import { Dashboard } from './negocio/Dashboard';
import { Miembros } from './negocio/Miembros';
import { MiembroDetalle } from './negocio/MiembroDetalle';
import { Invitar } from './negocio/Invitar';
import { Cobros } from './negocio/Cobros';
import { Comprobantes } from './negocio/Comprobantes';
import { Planes } from './negocio/Planes';
import { Ingresos } from './negocio/Ingresos';
import { Reportes } from './negocio/Reportes';
import { Referidos } from './negocio/Referidos';
import { Configuracion } from './negocio/Configuracion';
import { Suscripcion } from './negocio/Suscripcion';
import { Notificaciones } from './Notificaciones';
import { PlaceholderSection } from './PlaceholderSection';
import { useMePlan } from '../data/hooks';

export function BusinessArea() {
  const { session, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const unread = useUnreadCount();
  useNotificationsStream();
  const mePlan = useMePlan();
  const term = terminologyOf(session?.org?.type);

  const seg = loc.pathname.replace(/^\/app\/?/, '').split('/')[0] || 'dashboard';
  const active = PORTAL_NAV.some((n) => n.id === seg) ? seg : 'dashboard';
  const cap = (x: string) => x.charAt(0).toUpperCase() + x.slice(1);
  const items: NavItem[] = PORTAL_NAV.map((n) => (n.id === 'clientes' ? { ...n, label: cap(term.customerPlural) } : n));
  const current = items.find((n) => n.id === active);

  return (
    <PortalShell
      nav={items}
      active={active}
      onNav={(item) => nav(item.to ?? '/app')}
      title={current?.label ?? 'Dashboard'}
      org={session?.org ? { name: session.org.name, verticalLabel: term.business } : undefined}
      user={session ? { name: session.user.name } : undefined}
      notifCount={unread}
      onBell={() => nav('/app/notificaciones')}
      plan={mePlan.data ? { label: mePlan.data.effectiveTier === 'free' ? 'Plan Gratis' : `Plan ${mePlan.data.effectiveTier}`, used: mePlan.data.activeClients, limit: mePlan.data.effectiveFreeLimit, onUpgrade: () => nav('/app/suscripcion') } : undefined}
      actions={
        <>
          <ProfileSwitcher />
          <button onClick={logout} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text-muted)', borderRadius: 10, padding: '8px 12px', cursor: 'pointer', fontFamily: 'var(--font-sans)', fontWeight: 600 }}>Salir</button>
        </>
      }
    >
      <Routes>
        <Route index element={<Dashboard />} />
        <Route path="clientes" element={<Miembros />} />
        <Route path="clientes/invitar" element={<Invitar />} />
        <Route path="clientes/:id" element={<MiembroDetalle />} />
        <Route path="cobros" element={<Cobros />} />
        <Route path="comprobantes" element={<Comprobantes />} />
        <Route path="notificaciones" element={<Notificaciones />} />
        <Route path="suscripcion" element={<Suscripcion />} />
        <Route path="planes" element={<Planes />} />
        <Route path="ingresos" element={<Ingresos />} />
        <Route path="reportes" element={<Reportes />} />
        <Route path="referidos" element={<Referidos />} />
        <Route path="config" element={<Configuracion />} />
        <Route path="*" element={<PlaceholderSection title="Dashboard" />} />
      </Routes>
    </PortalShell>
  );
}
